<template>
  
        <div class="container clearfix">
            
            <div class="f-left"> 
                               
                <img src="@/assets/img/ico-menu.jpg" alt="menu" class="btn-menu" @click="onMenuItemSelected('OPEN_MENU')">                
                
            </div>
            <h1 class="f-center">
                <router-link to="/">
                    <img src="@/assets/img/logo-gongcha.jpg" alt="Gong cha">
                </router-link>
            </h1>
            <div class="f-right">
                <div class="box-alarm">
                    <!-- 알림이 있는 경우 -->
                    <a @click="onMenuItemSelected('ALARM')">
                        <img src="@/assets/img/ico-alarm-on.png" alt="알림" class="alarm-on" >
                    </a>
                    <!--// 알림이 있는 경우 -->
                </div>
                <!-- <a >
                    <img src="@/assets/img/ico-barcode.jpg" alt="barcode" @click="onMenuItemSelected('BARCODE')">
                </a> -->

            </div>
        </div>    
    
  
</template>
 
<script>



export default {
    
  name : "menu-top",
  methods:{
      onMenuItemSelected:function(menu){
        this.$emit('onMenuItemSelected',menu);
      },
    //   onMenuRightSelectedEvent:function(menu){
    //     this.$emit('onMenuRightSelectedEvent',menu);
    //     },
    //   openMenu:function(){
    //     console.log('MainHeader - openMenu');
    //     this.$emit('openMenu');
    //   }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/menuheader/MenuTop.vue